import { useQuery } from '@tanstack/react-query';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import type { FinancesDateRangeParams } from './apiHelpers';
import {
  getFinancesEarningsByTable,
  getFinancesEarningsTimeseries,
  getFinancesRefundBreakdown,
  getFinancesSummary,
} from './apiHelpers';

export const useFinancesSummary = (dateRange: FinancesDateRangeParams) => {
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    queryKey: ['restaurants', restaurantId, 'finances', 'summary', dateRange],
    queryFn: () => getFinancesSummary(restaurantId, dateRange),
  });
};

export const useFinancesEarningsTimeseries = (
  dateRange: FinancesDateRangeParams,
  compare = false,
) => {
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    queryKey: [
      'restaurants',
      restaurantId,
      'finances',
      'earnings-timeseries',
      dateRange,
      { compare },
    ],
    queryFn: () =>
      getFinancesEarningsTimeseries(restaurantId, dateRange, compare),
  });
};

export const useFinancesEarningsByTable = (
  dateRange: FinancesDateRangeParams,
) => {
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    queryKey: [
      'restaurants',
      restaurantId,
      'finances',
      'earnings-by-table',
      dateRange,
    ],
    queryFn: () => getFinancesEarningsByTable(restaurantId, dateRange),
  });
};

export const useFinancesRefundBreakdown = (
  dateRange: FinancesDateRangeParams,
) => {
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    queryKey: [
      'restaurants',
      restaurantId,
      'finances',
      'refund-breakdown',
      dateRange,
    ],
    queryFn: () => getFinancesRefundBreakdown(restaurantId, dateRange),
  });
};
